import { render, staticRenderFns } from "./FeaturedProducts.vue?vue&type=template&id=73570462&scoped=true&"
import script from "./FeaturedProducts.vue?vue&type=script&lang=js&"
export * from "./FeaturedProducts.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedProducts.vue?vue&type=style&index=0&id=73570462&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73570462",
  null
  
)

export default component.exports